import { SxProps } from "@mui/material";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

export const sxPagination: SxProps = {
    width: 'auto',
    height: '32px',
    background: 'unset',
    color: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset',
    position: 'unset',
    button: {
    fontFamily: 'UnimedSans-Bold',
    backgroundColor: '#EEE',
    color: '#5F5F5F'
    }
}

export const sxDoctorsCard: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    width: 'auto'
}

export const sxTextField: SxProps = {
    input: {
      fontFamily: 'Unimed-Sans', 
      color: '#383838', 
      fontSize: '14px', 
    }
}

export const sxTextFieldContrast: SxProps = {
    input: {
        fontFamily: 'Unimed-Sans', 
        color: 'white', 
        background: 'black',
        fontSize: '14px', 
      }
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px '
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px ',
    color: '#00995D',
    '&:focus': {
        background: '#fff',
    }
}

export const sxCalendar: SxProps = {

    width: '100%',
    ".MuiDateCalendar-root": {
        backgroundColor: '#00995D',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
    },
    ".MuiPickersCalendarHeader-root": {
        backgroundColor: '#00995D',
        color: '#fff',
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        paddingTop: '15px',
        paddingBottom: '15px',
        margin: '0',
        maxHeight: 'none',
    },
    ".MuiPickersCalendarHeader-labelContainer": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',
        
    },
    ".MuiDayCalendar-root": {
        backgroundColor: "#fff"
    },
    ".MuiPickersCalendarHeader-switchViewButton": {
        color: '#fff'
    },
    ".MuiPickersArrowSwitcher-button": {
        color: '#fff'
    },
    ".MuiDayCalendar-weekDayLabel": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',
        color: '#4C4C4C'
    },
    ".MuiPickersDay-root": {
        fontFamily: 'Unimed-Sans',
        color: '#175736',
        backgroundColor: '#90CAA6'
    },
    "MuiPickersDay-root:focus": {
        backgroundColor: '#00995D'
    },
    "MuiPickersDay-root:hover": {
        backgroundColor: '#00995D'
    },
    ".MuiPickersYear-yearButton": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C'
    },
    ".Mui-selected": {
        backgroundColor: '#00995D',
        color: "#fff"
    },
    ".Mui-selected:focus": {
        backgroundColor: '#00995D'
    },
    ".Mui-selected:hover": {
        backgroundColor: '#156D44'
    },
    ".Mui-disabled": {
        background: 'none'
    } ,
    '.MuiButton:hover .MuiButton-contained': {
        backgroundColor: '#00995D',
    }   
}

export const sxRadio: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px'
    } 
}

export const sxCheckbox: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#4C4C4C'
    } 
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '578px',
    width: '85%',
    maxHeight: '100vh',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    overflow: 'visible',
}

export const sxAutocomplete: SxProps = {
    '.MuiOutlinedInput-root': {
        padding: '4px 4px 7.5px 5px',
        fontFamily: 'Unimed-Sans' 
    }
}

export const sxTermsOfUseModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '650px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '100vh',
    overflow: 'auto'
}

export const sxLabel: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 600,
}

export const sxInput: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 400,
    fontSize: '14px'
}

export const sxError: SxProps = {
    color: '#D84141',
    fontSize: '12px'
}

export const sxRadioButton: SxProps = {
    marginBottom: '24px'
}

export const sxLabelCalendar: SxProps = {
    color: '#4C4C4C',
    fontWeight: 600,
    marginBottom: '16px'
}

export const sxBoxChevron: SxProps = {
    padding: '15px 20px 15px 20px'
}